import React from "react";
import styled from "@emotion/styled";

import { IconKey } from "../../../lib/icons/untitled_ui/UIcon";
import Collapsible from "../../ui/collapsible/Collapsible";
import { DisplayableEntities, getEntityLabel } from "../utils";

type Props = {
  children: React.ReactNode;
  entity: DisplayableEntities;
  entityCount: number;
};

const ICON_MAP: Record<DisplayableEntities, IconKey> = {
  notice: "file06",
  document: "box",
  framework: "grid01",
  supplier: "trophy01",
  buyer: "building08",
  contact: "userCircle",
};

export default function OpportunitySavedRow({ children, entity, entityCount }: Props) {
  return (
    <Collapsible
      key={entity}
      title={`${getEntityLabel(entity)} (${entityCount})`}
      icon={ICON_MAP[entity]}
      defaultOpen
    >
      <Content>{children}</Content>
    </Collapsible>
  );
}

const Content = styled.div({
  marginTop: 24,
});
